import React, { useEffect, useState } from 'react';
import { RegularLarge, SemiboldHeader2 } from '../../core/typography';
import { Form, FormInstance } from 'antd';
import FormInput from '../../../components/formBuilder/formBuilder';
import { LargePrimaryButton } from '../../../components/core/buttons';
import OldUserLogin from './old-user-login';
import NewUserLogin from './new-user-login';

interface EmailLoginProps {
    form: FormInstance;
    checkNewUser: () => void;
    userLogin: (values: { email: string; password: string }) => void;
    verifyCode:any;
    isNewUser: boolean;
    step: number;
    setStep: any;
    loading: boolean;
    setIsNewUser:any;
    setIsForgotPassword:any;
}

const EmailLogin: React.FC<EmailLoginProps> = ({ form, checkNewUser, isNewUser, step, setStep, loading, userLogin,verifyCode ,setIsNewUser,setIsForgotPassword}) => {
   
	const [formData, setFormData] = useState({ email: '' });
    const [mounted,setMounted]=useState(false);


    useEffect(()=>{
setMounted(true)
    },[form])
   
	const renderSecondScreen = () => {
        const email = form.getFieldValue('email'); 
        if (isNewUser) {
            return <NewUserLogin email={email} verifyCode={verifyCode} setStep={setStep}/>;
        } else {
            return <OldUserLogin loading={loading} form={form} setStep={setStep} userLogin={userLogin} email={email} setIsNewUser={setIsNewUser} setIsForgotPassword={setIsForgotPassword}/>;
        }
    };

    const renderFirstScreen = () => {
        return (
            <Form
                layout='vertical'
                initialValues={{ remember: true }}
                form={form}
                onChange={() => {
					setFormData(form.getFieldsValue());
                }}
            >
                <div className='w-full max-w-[360px]'>
                    <FormInput
                        className='auth-input'
                        name='email'
                        autoFocus
                        label='Email'
                        width='100%'
                        placeholder='Enter here'
                        onPressEnter={() => {
                            if (formData?.email?.length > 0) {
                                checkNewUser();
                            }
                        }}
                        rules={[
                            {
                                required: true,
                                message: 'Please enter your email',
                            },
                            {
                                type: 'email',
                                message: 'Please enter a valid email',
                            },
                        ]}
                    />
                </div>

                <div className='w-full mt-8 lg:mt-[40px]'>
                    <LargePrimaryButton
                        text={'Next'}
                        handleClick={checkNewUser}
                        style={{ width: '100%' }}
						disabled={formData?.email?.length < 1}
                        loading={loading}
                    />
                </div>
            </Form>
        );
    };

    const renderLoginScreens = (step: number) => {

        if(!mounted) return null;
        switch (step) {
            case 1:
                return renderFirstScreen();
            case 2:
                return renderSecondScreen();
            default:
                return null;
        }
    };

    let header = isNewUser ? 'Verify code' : 'Log in';
    let desc = 'Welcome back! Please enter your details.';
    return (
        <div className="w-full">
            <div className="text-left">
                <SemiboldHeader2 text={header} color={'#101828'} />
                <RegularLarge text={desc} color={'#475467'} />
            </div>

            <div className='mt-8 lg:mt-[40px]'>{renderLoginScreens(step)}</div>
        </div>
    );
};

export default EmailLogin;
